// Convert a YouTube/Vimeo watch URL into an embeddable URL.
export function embedUrl(url) {
  if (!url) return "";
  const u = url.trim();

  // YouTube: youtu.be/ID, youtube.com/watch?v=ID, youtube.com/shorts/ID, /embed/ID
  const yt =
    u.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://www.youtube.com/embed/${yt[1]}`;

  // Vimeo: vimeo.com/ID or player.vimeo.com/video/ID
  const vm = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vm) return `https://player.vimeo.com/video/${vm[1]}`;

  // Fallback: return as-is (already an embed or direct file)
  return u;
}

// Return a thumbnail image URL for a YouTube video, or "" if not derivable.
export function videoThumb(url) {
  if (!url) return "";
  const yt =
    url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return `https://i.ytimg.com/vi/${yt[1]}/hqdefault.jpg`;
  return "";
}
